export default __webpack_public_path__ + "static/media/1813.6930bf02.png";